"use client"
import React, { useState, useEffect } from "react";

var moment = require("moment");

const LocationOpenHoursLink = props => {
  const [label, setLabel] = useState(null);
  const showIcon = props.showIcon ? props.showIcon : true;

  useEffect(() => {
    var location = props.location;

    if (location.hours != null && typeof location.hours === "string") {
      var hoursObj = JSON.parse(location.hours);
      // get today, time and day
      var today = moment();
      var utcOffset = moment.parseZone(today).utcOffset();
      var minutes = utcOffset * -1;
      var dow = today.format("dddd");
      var dowCaps = dow.toUpperCase();
      // find the object that contains the day
      var dayObject = hoursObj.periods.find(
        period => period.open.day === dowCaps
      );
      if (dayObject != null) {
        // create the day from the name of the day
        var startOfDay = moment()
          .hours(
            dayObject.open && dayObject.open.time ? dayObject.open.time.hour : 0
          )
          .minutes(
            dayObject.open && dayObject.open.time
              ? dayObject.open.time.minute
              : 0
          );
        var endOfDay = moment()
          .hours(
            dayObject.close && dayObject.close.time
              ? dayObject.close.time.hour
              : 0
          )
          .minutes(
            dayObject.close && dayObject.close.time
              ? dayObject.close.time.minute
              : 0
          );
        if (
          dayObject.open &&
          dayObject.close &&
          dayObject.open.day !== dayObject.close.day
        ) {
          endOfDay = endOfDay.add(1, "days");
        }
        if (endOfDay.hour() <= startOfDay.hour()) {
          endOfDay = endOfDay.add(1, "days");
        }
        if (today.isBetween(startOfDay, endOfDay)) {
          setLabel("Open until " + endOfDay.format("h:mm a"));
        } else if (today.isBefore(startOfDay)) {
          setLabel("Opens at " + startOfDay.format("h:mm a"));
        } else if (today.isAfter(endOfDay)) {
          setLabel("Closed for today");
        } else {
          // NOOP
        }
      } else {
        setLabel("Closed today");
      }
    } else {
      // NOOP
    }
  }, [props]);

  if (props.location && label) {
    return (
      <div className="with-icon">
        <i className="text-color fa-solid fa-clock"></i>
        <span className="text-color">{label}</span>
      </div>
    );
  } else {
    return null;
  }
};
export default LocationOpenHoursLink;
